import { Repository } from 'vue-oop';

export default abstract class BaseRepository<T> extends Repository<T> {
}
